(function ($) {
	'use strict';

	/**
	 * If country flag not found, then use UN flag instead
	 */
	function flagNotLoaded() { // jshint ignore:line
		const $langFlag = $('#gen-language-flag');
		const fallbackUrl = $langFlag.data('baseUrl') + 'un.png';
		$langFlag.find('img').attr('src', fallbackUrl);
	}

	$(function () {

		const $googleTranslate = $('#gen_google_translate_element');
		const $langFlag = $('#gen-language-flag');

		/**
		 * Show/hide language menu on clicking flag
		 */
		$langFlag.on('click', function () {
			$googleTranslate.toggleClass('visible');
		});

		/**
		 * On changing language, update the language flag
		 */
		$googleTranslate.on('change', '.goog-te-combo', function () {

			const lang = this.value;
			const baseUrl = $langFlag.data('baseUrl');
			const imgUrl = baseUrl + lang + '.png';
			const img = $langFlag.find('img');

			//change the image
			img.attr('src', imgUrl);

			//hide the language menu again
			$googleTranslate.removeClass('visible');
		});

	});

}(GEN$));
